// extracted by mini-css-extract-plugin
export var chip = "_3t-0";
export var filterDropdown = "_3t-5";
export var filterItem = "_3t-6";
export var icon = "_3t-1";
export var removeButton = "_3t-3";
export var removeIcon = "_3t-4";
export var separator = "_3t-2";